import Bugsnag from "@bugsnag/js";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import SEO from "react-seo-component";
import Login from "../../components/Login";
import ContentLoader from "../../components/common/ContentLoader";
import util from "../../util";
import CustomerProfileMenu from "../customer-profile/CustomerProfileMenu";
import ProfileMenuHeader from "../customer-profile/ProfileMenuHeader";

import cookie from "react-cookies";
import {
  Button,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import constants from "../../Constants";

const baseURL = constants.baseURL;
class Section extends Component {
  constructor() {
    super();

    this.state = {
      loading: false,
      success: false,
      openSuccessModal: false,
      trucktype: "1.5tonopen",
      apierror: "",
      startdate: "",
      enddate: "",
      homelat: 0,
      homelng: 0,
      description: "",
      vehicletypes: [],
      sellingprice: 0,
      contracts: [],
      contractvehicles: {},
    };
  }

  getVehicleTypes() {
    const { vehicletypes } = this.state;
    if (vehicletypes?.length === 0)
      axios.get(baseURL + "/contract-vehicle-hire-types").then((repos) => {
        const vehicletypesdata = repos.data;
        this.setState({
          vehicletypes: vehicletypesdata?.vehicles,
          vehiclecategories: vehicletypesdata?.categories,
          vehicleconfigurations: vehicletypesdata?.configurations,
        });
      });
  }
  calcSellingPrice(startdate, enddate, trucktype) {
    const { vehicletypes } = this.state;
    var a = moment(startdate);
    var b = moment(enddate);
    console.log(a);
    console.log(b);
    const days = b.diff(a, "days") + 1;
    let rate = "dailyrate";
    if (days > 6 && days <= 27) rate = "weeklyrate";
    if (days > 27) rate = "monthlyrate";

    console.log(days);
    console.log(rate);
    return vehicletypes.find((v) => v.type === trucktype)[rate] * days;
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextState.startdate !== this.state.startdate ||
      nextState.enddate !== this.state.enddate ||
      nextState.trucktype !== this.state.trucktype
    ) {
      const sellingprice = this.calcSellingPrice(
        nextState.startdate,
        nextState.enddate,
        nextState.trucktype
      );
      this.setState({ sellingprice }, () => {
        if (sellingprice > 0) this.submitQuote();
      });
    }
    return true;
  }

  componentDidMount() {
    if (cookie.load("qtcid_")) {
      this.getCustomerProfile();
      this.getCustomerContracts();
    }
  }
  getCustomerProfile() {
    this.setState({ loading: true });

    axios
      .get(baseURL + "/customer-profile", {
        headers: {
          "Content-Type": "application/json",
          Authorization: cookie.load("qtcid_"),
        },
      })
      .then((response) => {
        this.setState({
          profile: response.data,
        });
      })
      .catch((e) => {
        this.setState({ apierror: e.message });
        Bugsnag.notify(e);
      })
      .finally(() => this.setState({ loading: false }));
  }
  getCustomerContracts() {
    this.setState({ loading: true });
    axios
      .get(baseURL + "/customer-get-contracts", {
        headers: {
          "Content-Type": "application/json",
          Authorization: cookie.load("qtcid_"),
        },
      })
      .then((response) => {
        this.setState({
          contracts: response.data,
        });

        if (response.data.length === 1)
          this.getCustomerContractVehicles(response.data[0].customercontractid);
      })
      .catch((e) => {
        this.setState({ apierror: e.message });
        Bugsnag.notify(e);
      })
      .finally(() => this.setState({ loading: false }));
  }
  getCustomerContractVehicles(customercontractid) {
    this.setState({ loadingvehicles: true });
    axios
      .get(
        baseURL +
          "/customer-get-contract-vehicles?customercontractid=" +
          customercontractid,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: cookie.load("qtcid_"),
          },
        }
      )
      .then((response) => {
        const cv = { ...this.state.contractvehicles };
        cv[customercontractid] = response.data;
        this.setState({
          contractvehicles: cv,
        });
      })
      .catch((e) => {
        this.setState({ apierror: e.message });
        Bugsnag.notify(e);
      })
      .finally(() => this.setState({ loadingvehicles: false }));
  }
  submitQuote() {
    const {
      trucktype,
      startdate,
      enddate,
      homelat,
      homelng,
      description,
      sellingprice,
      profile: { customerid },
    } = this.state;

    axios
      .post(baseURL + "/customer-create-contract-quote", {
        trucktype,
        startdate,
        enddate,
        homelat,
        homelng,
        description,
        sellingprice,
        customerid,
        source_:
          util.navigator_() + util.source_() + " qtref:" + document?.referrer,
      })
      .catch((e) => {});
  }

  getImage(trucktype) {
    try {
      return `https://media.qiktruck.co.za/${trucktype}.png`;
    } catch (error) {
      return "";
    }
  }

  render() {
    this.getVehicleTypes();
    const { contracts } = this.state;
    return (
      <React.Fragment>
        {!cookie.load("qtcid_") && <Login />}
        <div id={"pagefragmenttop"}></div>
        <SEO
          title={"Hire a truck for your deliveries Today"}
          titleTemplate={"QikTruck"}
          titleSeparator={`-`}
          description={
            "Online quotation today for hire a truck with a diver to transport your goods."
          }
          image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
          pathname={"https://qiktruck.co.za/truck-hire"}
          twitterUsername={"qiktrucksa"}
        />
        <section className="hero-section" id={"pagetop"}>
          <Modal isOpen={this.state.success && this.state.openSuccessModal}>
            <ModalHeader>
              <i className={"mdi mdi-check-circle  order-received"}></i>
              Request Received
            </ModalHeader>
            <ModalBody>
              <ListGroup className="black-text">
                <ListGroupItem>
                  <i className={"mdi mdi-check-circle order-received-list"}></i>
                  Our team will be in touch shortly to confirm your order.
                </ListGroupItem>
                <ListGroupItem>
                  <i className={"mdi mdi-check-circle order-received-list"}></i>
                  Happy moving!
                </ListGroupItem>
              </ListGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={() => window.location.reload()}>
                Okay
              </Button>
            </ModalFooter>
          </Modal>

          <Container>
            <div className="store-front">
              <Row>
                <Col lg={12}>
                  <div className="hero-wrapper mb-4">
                    <div id={"vehiclelist"}></div>

                    {this.state.loading && <ContentLoader />}
                    <ProfileMenuHeader heading={"Your contracts"} />
                    <br />
                    <br />
                    <br />
                    {contracts?.length === 0 && (
                      <>
                        <p>
                          You do not have any contracts.{" "}
                          <a href="/customer-truck-hire">
                            Create a Daily, Weekly or Monthly contract.
                          </a>
                        </p>
                        <p>
                          Or book a <a href="/#quotestart">once off trip</a>
                        </p>
                      </>
                    )}
                    {contracts?.map((vehicle) => {
                      const image = this.getImage(vehicle.trucktype);
                      return (
                        <Row className={"grey-border-bottom"}>
                          <Col
                            key={vehicle.customercontractquoteid}
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            xl={6}
                            onClick={() =>
                              this.setState({
                                contract: vehicle.customercontractquoteid,
                              })
                            }
                          >
                            <span
                              className={
                                "contract-summary-status " +
                                vehicle.contractstatus
                              }
                            >
                              {vehicle.contractstatus ||
                                "Application in review"}
                            </span>

                            <img
                              src={image}
                              alt=""
                              className={"contract-vehicle-list-image"}
                            />

                            <p className="contract-summary">
                              <span className="contract-summary-description">
                                {vehicle.vehiclecount} vehicle(s) at{" "}
                                {vehicle.quotedistance / vehicle.vehiclecount}
                                km per vehicle
                              </span>

                              <br />
                              <span>
                                {moment(vehicle.enddate).diff(
                                  moment(vehicle.startdate),
                                  "days"
                                ) + 1}{" "}
                                day(s)
                              </span>
                              <br />

                              <span className="contract-summary-description">
                                {vehicle.description}
                              </span>
                              <br />
                              <p>
                                <span className="contract-summary-date">
                                  {moment(vehicle.startdate).format(
                                    "MMM DD YYYY"
                                  )}
                                  {" - "}
                                </span>
                                <span className="contract-summary-date">
                                  {" "}
                                  {moment(vehicle.enddate).format(
                                    "MMM DD YYYY"
                                  )}{" "}
                                </span>
                              </p>
                              {/* <b>
                                <CurrencyFormat
                                  value={vehicle.sellingprice / 100} //cents to rands
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"R"}
                                  decimalScale={2}
                                  className="contract-summary-price"
                                />
                              </b> */}
                              <span className={"contract-summary-id "}>
                                {vehicle.customercontractid.split("-")[0]}
                              </span>
                              <br />
                              {vehicle.contractstatus && (
                                <p style={{ width: "100%", float: "left" }}>
                                  <button
                                    className={"contract-summary-button "}
                                    onClick={() => {
                                      this.getCustomerContractVehicles(
                                        vehicle.customercontractid
                                      );
                                    }}
                                  >
                                    List vehicles >>
                                  </button>
                                  <a
                                    className={"contract-summary-button "}
                                    href={
                                      "/contract-trips?customercontractid=" +
                                      vehicle.customercontractid
                                    }
                                  >
                                    Contract trips >>
                                  </a>
                                </p>
                              )}
                            </p>
                          </Col>
                          <Col
                            key={vehicle.customercontractquoteid}
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            xl={6}
                            className={"vehicle-hired-list"}
                          >
                            {this.state?.loadingvehicles && <b>Loading...</b>}
                            {this.state?.contractvehicles[
                              vehicle.customercontractid
                            ]?.length > 0 && (
                              <>
                                <h6 style={{ marginTop: "10px" }}>
                                  Your vehicles
                                </h6>
                                <p>Click on a vehicle to assign a job</p>
                              </>
                            )}
                            {this.state?.contractvehicles[
                              vehicle.customercontractid
                            ]
                              ?.sort((a, b) =>
                                b.trucktype[0].localeCompare(a.trucktype[0])
                              )
                              ?.map((cv) => {
                                const cvimage = this.getImage(cv.trucktype);
                                return (
                                  cv.activationstatus !== "removed" && (
                                    <div
                                      className={
                                        "contract-vehicles-list " +
                                        (vehicle.trucktype === cv.trucktype
                                          ? "defaultvehicle"
                                          : "")
                                      }
                                    >
                                      <a
                                        className="vehicle-names"
                                        href={
                                          "/checkout-load-capacity?v=" +
                                          cv.vehicleid +
                                          "&customercontractid=" +
                                          vehicle.customercontractid
                                        }
                                      >
                                        <img
                                          src={cvimage}
                                          alt=""
                                          className={
                                            "contract-vehicle-list-imagecv"
                                          }
                                        />
                                        <span>
                                          {vehicle.trucktype === cv.trucktype
                                            ? "<< default >>"
                                            : "last mile"}
                                        </span>
                                        {cv.firstname} {cv.lastname}{" "}
                                        {cv.licensenumber}
                                      </a>
                                    </div>
                                  )
                                );
                              })}
                          </Col>
                        </Row>
                      );
                    })}
                    <hr />
                    <a href="/customer-truck-hire">Create a contract > </a>
                    <CustomerProfileMenu profile={this.state.profile} />
                    {this.state.loading === false &&
                      this.state.apierror.length > 0 && (
                        <p className="error-message">{this.state.apierror}</p>
                      )}
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
